import { createColumnHelper } from "@tanstack/react-table";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { dateFormatter } from "../../../utils/dateFormatter";
import { StatusPill } from "../../order/orderTable/orderTableColumnsConfig";
const columnHelper = createColumnHelper();

export const cancellationTableColumnsConfig = (handleNavigateToDetail) => [
  columnHelper.accessor("id", {
    header: "ID",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("user_id", {
    header: "User Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("ordered_on", {
    header: "Ordered On",
    cell: (info) => dateFormatter(info.getValue()),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("postal_code", {
    header: "PinCode",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("total_amount", {
    header: "Total Amount",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("order_status_label", {
    header: "Order Status",
    cell: ({ getValue }) => {
      const status = getValue()?.toLowerCase();

      const configMap = {
        "cancellation requested": {
          label: "Cancellation Requested",
          bg: "#FFF4E5",
          color: "#FF9500",
          Icon: ClockIcon,
        },
        cancelled: {
          label: "Cancelled",
          bg: "#E6F7EF",
          color: "#00A167",
          Icon: CheckCircleIcon,
        },
        "cancellation rejected": {
          label: "Cancellation Rejected",
          bg: "#FDECEA",
          color: "#D92D20",
          Icon: XCircleIcon,
        },
      };

      const config = configMap[status];

      if (!config) return "-";

      return <StatusPill {...config} />;
    },
  }),

  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={actionBtnStyle}
          onClick={() => handleNavigateToDetail(props.row.original.id)}
        >
          View Details
        </button>
      </div>
    ),
  }),
];

const actionBtnStyle = {
  padding: "6px 12px",
  background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
  color: "#FFFFFF",
  fontWeight: 500,
  fontSize: "13px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
};
